<template>
  <div class="lifebar" v-if="playerData">
    <img :src="playerData.img" :alt="playerData.name">

    <div class="lifebar__infos">
      <div class="lifebar__infos__detail">
        <p>{{ playerData.name }}</p>
        <p> - </p>
        <p>{{ getMoney }} M€</p>
      </div>
    
      <div class="lifebar__bar">
        <div :class="['lifebar__bar-progress', more ? 'lifebar__bar-progress--more' : '', less ? 'lifebar__bar-progress--less' : '']">
          <span :style="{ width: `${widthBar}px`}"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Cookie from 'js-cookie';

  export default {
    name: 'lifebar',
    data() {
      let playerData = this.getPlayer;

      if (!playerData) {
        playerData = JSON.parse(Cookie.get('player'));
        this.$store.commit('setPlayer', playerData);
        this.$store.commit('setMoney', parseInt(Cookie.get('money'), 10));
      }

      if (!playerData) {
        this.$router.go('/');
      }

      return {
        widthBar: 0,
        playerData: playerData,
        more: false,
        less: false,
      };
    },
    mounted() {
      const self = this;
      
      if (this.playerData) {
        this.initDOM();
        this.calcBar();
      }

      window.addEventListener('resize', () => {
        self.calcBar();
      });
    },
    methods: {
      initDOM() {
        this.progressBar = document.querySelector('.lifebar__bar-progress');
      },
      calcBar() {
        const width = this.progressBar.offsetWidth * (this.$store.getters.getMoney / 50);
        this.widthBar = width;
      },
    },
    watch: {
      getMoney(n) {
        const self = this;
        const width = this.progressBar.offsetWidth * (n / 50);

        if (width > this.widthBar) {
          this.more = true;
        } else {
          this.less = true;
        }

        this.widthBar = width;

        setTimeout(() => {
          self.more = false;
          self.less = false;
        }, 1000);
      },
    },
    computed: {
      getPlayer() {
        return this.$store.getters.getPlayer;
      },
      getMoney() {
        return this.$store.getters.getMoney;
      },
    },
  };
</script>


<style lang="scss">
  .lifebar {
    position: absolute;
    top: 50px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    opacity: 0;
    animation: lifeBarAppear .4s ease-in-out forwards;

    @keyframes lifeBarAppear {
      0% {
        opacity: 0;
        transform: translateX(-50%) translateY(-20px);
      }
      100% {
        opacity: 1;
        transform: translateX(-50%) translateY(0);
      }
    }

    @include mobile {
      top: 110px;
      width: 90%;
    }

    img {
      margin-right: 15px;
      max-width: 50px;

      @include mobile {
        max-width: 50px;
      }
    }
  }

  .lifebar__infos {
    @include mobile {
      width: calc(100% - 65px);
    }
  }

  .lifebar__infos__detail {
    display: flex;
    align-items: center;

    p {
      color: $blue;
      font-weight: 600;
      margin-bottom: 5px;
      @include fontSize(18);

      &:nth-child(2) {
        position: relative;
        top: -3px;
        display: inline-block;
        margin: 0 10px;
      }
    }
  }

  .lifebar__bar {
    display: flex;
    align-items: center;

    @include mobile {
      display: block;
    }

    p {
      color: $blue;
      font-weight: 600;
      margin-left: 10px;
      @include fontSize(18);

      @include mobile {
        margin-top: 5px;
      }
    }
  }

  .lifebar__bar-progress {
    position: relative;
    width: 250px;
    height: 18px;
    background: $beige url('../../assets/img/bg_bar.png') repeat;
    box-shadow: 1px 1px 0 0 $blue;
    border-radius: 7px;
    overflow: hidden;

    @include mobile {
      width: 100%;
    }

    &.lifebar__bar-progress--more span {
      background: $win;
    }

    &.lifebar__bar-progress--less span {
      background: $fail;
    }

    span {
      position: absolute;
      left: 0;
      top: 0;
      height: 100%;
      background: $orange;
      @include defaultTransition(.4);
    }
  }
</style>



// WEBPACK FOOTER //
// Lifebar.vue?d6bfbec8